import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lookupContainsId'
})
export class LookupContainsIdPipe implements PipeTransform {

  transform(value: any, id: any, selectedId: any, notStr: string = ''): any {
    let not = !!notStr && notStr.toLocaleLowerCase() === 'invert';
    if (value.length === null || !id){
      return value;
    }

    let resultArray = [];
    for (let item of value) {
      let ok = true;
      if (id.length === null) {
        if (item.id === id && item.id !== selectedId) {
          if (not) {
            ok = false;
          } else {
            resultArray.push(item);
          }
        }
      } else {
        for (let ii of id) {
          if (ii === item.id && item.id !== selectedId) {
            if (not) {
              ok = false;
            } else {
              resultArray.push(item);
            }
            break;
          }
        }
      }

      if (not && ok) {
        resultArray.push(item);
      }
    }

    return resultArray;
  }

}
